// extracted by mini-css-extract-plugin
export var category_related_board = "category-module--category_related_board--3Z-SY";